var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"readonly":"","dense":"","reverse":"","label":"Credits Available:","loading":_vm.accountLoading,"value":_vm.accountLoading ? '...loading...' : _vm.credits}})}
var staticRenderFns = []

export { render, staticRenderFns }